// NEXIS Lab — shared team workspace API (projects/reports/activity sync).
const API = process.env.REACT_APP_BACKEND_URL;
const base = `${API}/api/lab`;

const opts = (method, body) => ({
  method,
  credentials: "include",
  headers: { "Content-Type": "application/json" },
  ...(body ? { body: JSON.stringify(body) } : {}),
});

export async function fetchWorkspace() {
  const r = await fetch(`${base}/workspace`, { credentials: "include" });
  if (!r.ok) throw new Error("workspace");
  return r.json();
}

export async function saveProject(projectId, data, baseVersion, action, detail) {
  const r = await fetch(`${base}/projects/${projectId}`, opts("PUT", {
    data, base_version: baseVersion ?? null, action, detail,
  }));
  if (r.status === 409) {
    const d = await r.json().catch(() => ({}));
    const e = new Error("conflict");
    e.conflict = d?.detail?.current || null;
    throw e;
  }
  if (!r.ok) {
    const d = await r.json().catch(() => ({}));
    const e = new Error(typeof d.detail === "string" ? d.detail : "save failed");
    e.status = r.status;
    throw e;
  }
  return r.json();
}

export async function deleteProjectApi(projectId) {
  await fetch(`${base}/projects/${projectId}`, opts("DELETE"));
}

export async function saveReports(reports) {
  await fetch(`${base}/reports`, opts("PUT", { reports }));
}

export async function fetchActivity(projectId) {
  const q = projectId ? `?project_id=${encodeURIComponent(projectId)}` : "";
  const r = await fetch(`${base}/activity${q}`, { credentials: "include" });
  return r.ok ? r.json() : [];
}

export async function migrateLocal(projects, reports) {
  const r = await fetch(`${base}/migrate`, opts("POST", { projects, reports }));
  return r.ok ? r.json() : { imported: 0, skipped: 0 };
}

export async function exportWorkspace() {
  const r = await fetch(`${base}/export`, { credentials: "include" });
  return r.ok ? r.json() : null;
}


export async function updateProfile(body) {
  const r = await fetch(`${API}/api/auth/profile`, opts("PATCH", body));
  if (!r.ok) {
    const d = await r.json().catch(() => ({}));
    throw new Error(typeof d.detail === "string" ? d.detail : "failed");
  }
  return r.json();
}

export async function changePassword(currentPassword, newPassword) {
  const r = await fetch(`${API}/api/auth/change-password`, opts("POST", {
    current_password: currentPassword, new_password: newPassword,
  }));
  if (!r.ok) {
    const d = await r.json().catch(() => ({}));
    const e = new Error(typeof d.detail === "string" ? d.detail : "failed");
    e.status = r.status;
    throw e;
  }
  return r.json();
}
